import { Paper, Stack, Typography } from '@mui/material';
import { Button } from '../ui/Button';
import {
  REGISTER_CARD_SX,
  REGISTER_HELPER_SX,
  REGISTER_SECTION_TITLE_SX,
} from './registerSurfaces';

/**
 * Figma Composite: section card used across register wizard steps.
 * Optional trailing edit action powers the Step 4 review → step navigation.
 */
export function RegisterSectionCard({
  title,
  helper,
  actionLabel,
  onAction,
  testId,
  children,
  sx,
}) {
  return (
    <Paper elevation={0} sx={{ ...REGISTER_CARD_SX, ...sx }} data-testid={testId}>
      {(title || actionLabel) ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={2}
          sx={{ mb: helper ? 0.5 : 1.5 }}
        >
          {title ? (
            <Typography component="h3" sx={REGISTER_SECTION_TITLE_SX}>{title}</Typography>
          ) : <span />}
          {onAction && actionLabel ? (
            <Button
              variant="Ghost"
              size="small"
              onClick={onAction}
              data-testid={testId ? `${testId}-edit` : undefined}
            >
              {actionLabel}
            </Button>
          ) : null}
        </Stack>
      ) : null}
      {helper ? (
        <Typography sx={{ ...REGISTER_HELPER_SX, mb: 1.5 }}>{helper}</Typography>
      ) : null}
      {children}
    </Paper>
  );
}

export default RegisterSectionCard;
